import { Component, OnInit, Input, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DialogService } from 'src/app/shared/service/dialog.service';
import { AuthService } from 'src/app/shared/service/auth.service';
import { AdminRolesEnum } from 'src/app/shared/enums/admin-roles.enum';
import { Messages } from 'src/app/shared/messages/messages';
import { CnaeCreditRiskModel } from '../../models/cnae-credit-risk.model';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { FdFieldConfigs } from 'src/app/shared/fd-form-components/fd-form-components.module';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-list-cnaes',
    templateUrl: './list-cnaes.component.html',
    styleUrls: ['./list-cnaes.component.scss'],
    standalone: false
})
export class ListCnaesComponent {

  displayedColumns =
    ['cnaeNumber', 'prepaymentAllowed','mdrFlexAllowed','ableForeignCard',
    'technologies','options_edit'];

  defaultSizeItems = 10;
  formGroup: UntypedFormGroup;
  fields: FdFieldConfigs;
  totalPages: number;
  itemsNotFoundByFilter = false;

  @Input() totalItens;

  @Input() dataSource: MatTableDataSource<CnaeCreditRiskModel>;
  originalDataSource = new MatTableDataSource<CnaeCreditRiskModel>();

  @Output() changePage = new EventEmitter<PageEvent>();
  @Output() onSearch = new EventEmitter<void>();
  @Output() deleteItem = new EventEmitter<CnaeCreditRiskModel>();
  @Output() enableItem = new EventEmitter<CnaeCreditRiskModel>();
  @Output() itemDetails = new EventEmitter<CnaeCreditRiskModel>();
  @Output() editItem = new EventEmitter<CnaeCreditRiskModel>();

  @ViewChild('binding') binding: ElementRef;
  expandedElement: CnaeCreditRiskModel;

  constructor(
    private dialogService: DialogService,
    private authService: AuthService,
    private formBuilder: UntypedFormBuilder
  ) { }

  ngOnInit(){
    this.startForms();
    this.dataSource.connect().subscribe(response => {
      if(response && response.length){
        this.originalDataSource.data = this.dataSource.data;
      }
    })
  }

  disconnect() {
    this.dataSource.disconnect();
  }
  
  startForms() {
    this.formGroup = this.formBuilder.group({
      cnaeFilter: [''],
    });

    this.fields = {
      cnaeFilter: {
        label: 'Filtrar CNAE',
        controlName: 'cnaeFilter'
      },
    };
  }

  get hasWriteAccess() {
    return this.authService.isUserInRoles([AdminRolesEnum.CNAE_CREDIT_RISK_WRITE]);
  }

  get hasValue() {
    return this.dataSource && this.dataSource.data && this.dataSource.data.length;
  }
 
  delete(select: any) {
    this.dialogService.openConfirmDialog(Messages.CONFIRM_DELETE_ACTION, () => this.deleteItem.emit(select));
  }

  enable(select: any) {
    this.dialogService.openConfirmDialog(Messages.CONFIRM_ENABLE_ACTION, () => this.enableItem.emit(select));
  }

  detail(cnaeCreditRisk: CnaeCreditRiskModel) {
    this.itemDetails.emit(cnaeCreditRisk);
  }

  edit(cnaeCreditRisk: CnaeCreditRiskModel) {
    this.editItem.emit(cnaeCreditRisk);
  }

  change(event: PageEvent): void {
    this.changePage.emit(event);
  }

}
